/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../../utils/Functions';
import { PatternTwoModel } from '../../../ShareModel/PatternModel/PatternTwoModel';

const SectionalWithWindowDoor = ({ width, height, trimWidth, doorColor, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    const deviation = 0.03;
    const defaultWidth = 6;
    const defaultHeight = 6;
    const doorWidth = defaultWidth - trimWidth - deviation * 4;
    const doorHeight = defaultHeight - trimWidth - deviation * 4;
    const holeWidthSize = 1.3;
    const holeHeightSize = 1
    const holeDistanceLimitX = 0.05;
    const holeDistanceLimitY = 0.2;
    const holeAreaSizeW = holeWidthSize + holeDistanceLimitX * 2;
    const holeAreaSizeH = holeHeightSize + holeDistanceLimitY * 2;
    const holeCountX = 4;
    const holeCountY = 4;
    const holeDistanceX = 0.0359
    const holeDistanceY = 0.036
    const borderLineDistanceY = 1.445

    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();

        return model
    }, [width, height])

    const doorModel = useMemo(() => {        
        const model = new THREE.Shape();
        model.moveTo(-(defaultWidth / 2 - deviation) + trimWidth,  -(defaultHeight / 2 - deviation));
        model.lineTo(-(defaultWidth / 2 - deviation) + trimWidth,  (defaultHeight / 2) - trimWidth);
        model.lineTo((defaultWidth / 2 - deviation) - trimWidth,  (defaultHeight / 2) - trimWidth);
        model.lineTo((defaultWidth / 2 - deviation) - trimWidth,  -(defaultHeight / 2 - deviation));
        model.closePath();

        for (let i = 1; i <= holeCountX; i++) {
            for (let j = 1; j <= holeCountY; j++) {
                const hole = new THREE.Path();
                hole.moveTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX,              -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY + holeHeightSize);
                hole.lineTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX,              -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY);
                hole.lineTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX + holeWidthSize,   -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY);
                hole.lineTo(-doorWidth / 2 + holeDistanceX * i + holeAreaSizeW * (i - 1) + holeDistanceLimitX + holeWidthSize,   -doorHeight / 2 + holeDistanceY * j + holeAreaSizeH * (j - 1) + holeDistanceLimitY + holeHeightSize);
                hole.closePath();

                model.holes.push(hole);
            }
        }

        return model;
    
    }, [])

    const insideDoorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(defaultWidth / 2) + trimWidth,  -(defaultHeight / 2));
        model.lineTo(-(defaultWidth / 2) + trimWidth,  (defaultHeight / 2 - borderLineDistanceY) - trimWidth);
        model.lineTo((defaultWidth / 2) - trimWidth,  (defaultHeight / 2 - borderLineDistanceY) - trimWidth);
        model.lineTo((defaultWidth / 2) - trimWidth,  -(defaultHeight / 2));
        model.closePath();

        return model;
    
    }, [])
    
    const glassTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-holeWidthSize / 2, holeHeightSize / 2);
        model.lineTo(-holeWidthSize / 2, -holeHeightSize / 2);
        model.lineTo(holeWidthSize / 2, -holeHeightSize / 2);
        model.lineTo(holeWidthSize / 2, holeHeightSize / 2);
        model.closePath();
        
        const hole = new THREE.Path();
        hole.moveTo(-(holeWidthSize / 2 - 0.001), -(holeHeightSize / 2 - 0.001));
        hole.lineTo(-(holeWidthSize / 2 - 0.001), (holeHeightSize / 2 - 0.001));
        hole.lineTo((holeWidthSize / 2 - 0.001), (holeHeightSize / 2 - 0.001));
        hole.lineTo((holeWidthSize / 2 - 0.001), -(holeHeightSize / 2 - 0.001));
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [holeWidthSize, holeHeightSize])
    
    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(defaultHeight / 2) + trimWidth,  defaultHeight / 2 - trimWidth);
        model.lineTo(-(defaultHeight / 2) + trimWidth,  defaultHeight / 2 - trimWidth- borderLineDistanceY);
        model.lineTo((defaultHeight / 2) - trimWidth,  defaultHeight / 2 - trimWidth- borderLineDistanceY);
        model.lineTo((defaultHeight / 2) - trimWidth,  defaultHeight / 2 - trimWidth);
        model.closePath();

        return model;
    
    }, [])
    
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <group scale={[(width - 0.2) / 5.8, (height - 0.1) / 5.9, 1]}>
                <mesh name='glass-doorModel' position={[0, 0, 0.05]}>
                    <extrudeGeometry args={[doorModel, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                </mesh>
                <mesh name='glass-insideDoorModel' position={[0, 0, 0.145]}>
                    <extrudeGeometry args={[insideDoorModel, extrudeSettings(0.01)]} />
                    <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                </mesh>
                
                {new Array(2).fill("").map((_, indexI) =>
                    new Array(holeCountY - 1).fill("").map((_, indexJ) =>
                        <mesh key={`border-line-${indexI}-${indexJ}`} name='glass-border-line-models' position={[0, -doorHeight / 2 + borderLineDistanceY * (indexJ + 1), 0.02 + 0.25 * indexI]} rotation={[0, 0, Math.PI / 2]}>
                            <cylinderGeometry args={[0.02, 0.02, (defaultWidth - trimWidth * 2), 15, 1]} />
                            <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                        </mesh>
                    )
                )}
                
                {new Array(holeCountX).fill("").map((_, indexI) =>
                    new Array(holeCountY - 1).fill("").map((_, indexJ) => 
                        <group key={`pattern-model-${indexI}-${indexJ}`} name='pattern-models' position={[
                            -doorWidth / 2 + holeDistanceX * (indexI + 1) + holeAreaSizeW / 2 + holeAreaSizeW * indexI,
                            -doorHeight / 2 + holeDistanceY * (indexJ + 1) + holeAreaSizeH / 2 + holeAreaSizeH * indexJ,
                            0.14]}
                        >
                            <PatternTwoModel modelWidth={holeWidthSize - 0.06} modelHeight={holeHeightSize - 0.06} doorColor={doorColor}  />
                        </group>
                    )
                )}

                {new Array(holeCountX).fill("").map((_, index) =>
                        <mesh key={`trim-model-${index}`} name='pattern-models' position={[
                            -doorWidth / 2 + holeDistanceX * (index + 1) + holeAreaSizeW / 2 + holeAreaSizeW * index,
                            -doorHeight / 2 + holeDistanceY * (holeCountY) + holeAreaSizeH / 2 + holeAreaSizeH * (holeCountY - 1),
                            0.14]}
                        >
                            <extrudeGeometry args={[glassTrimModel, extrudeSettings(0.01, 0.14, 0.14, 0, 1)]} />
                            <meshStandardMaterial  color={doorColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} />
                        </mesh>
                )}            
                <mesh name='glass' position={[0, 0, 0.1]}>
                    <extrudeGeometry args={[glassModel, extrudeSettings(0.1)]} />
                    <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
                </mesh>
            </group>
        </>
    )
}

export default SectionalWithWindowDoor